module.exports = __webpack_public_path__ + "static/media/woman-icon.c64728b9.png";